import * as $ from 'jquery';
import { CarouselUniversalCommon } from './carousel-universal-common';

export class CarouselUniversalFrontend {

    static init() {
        $(document).ready(() => {
            let hoverEffect = $('.style-v2 .brochure.hover-effect');
            $('.carousel-universal-component .component-universal-carousel').each((i, cr) => {
                let carousel = $(cr);
                let itemsPerPage = carousel.parent().attr('data-items-per-page');
                CarouselUniversalCommon.initSlick(carousel, itemsPerPage);
                CarouselUniversalCommon.subscribeResize(() => CarouselUniversalCommon.initSlick(carousel, itemsPerPage));
            })
            CarouselUniversalCommon.disableSlickDrag();
            hoverEffect.first().addClass('hover-active');
            hoverEffect.mouseenter(function () {
                let activeElement = document.getElementsByClassName('hover-active');
                if (typeof activeElement !== 'undefined' && activeElement.length !== 0) {
                    activeElement[0].classList.add('hover-inactive')
                }
            });
            hoverEffect.mouseleave(function () {
                let activeElement = document.getElementsByClassName('hover-active');
                if (typeof activeElement !== 'undefined' && activeElement.length !== 0) {
                    activeElement[0].classList.remove('hover-inactive')
                }
            });
        });
    }
}
